import React, { Component } from 'react';
import logo from '@assets/img/logo.svg';
import { Link } from 'dva/router';
import classNames from 'classnames';
import styles from './index.less';
import { scrollToFeedback } from '../../utils';
import menuIcon from '../../assets/img/menu.svg';


function WebHeader(props) {
  return (
    <header className={styles.header}>
      <div className={classNames('frame-wrapper', styles.navContainer)}>
        <div className={classNames(styles.left)}>
          <Link to="/" className={styles.linkLogo}><img className={styles.navLogo} src={logo} alt="logo" /><span className={classNames(styles.title)}>大疆供应商平台</span></Link>
          <Link to="/principle" className={classNames(styles.mgLeft, styles.link)}>采购原则</Link>
          <Link to="/process" className={classNames(styles.mgLeft, styles.link)}>供应商引入流程</Link>
          <a className={classNames(styles.mgLeft, styles.link)} onClick={() => scrollToFeedback(props)}>投诉反馈</a>
        </div>
        <div className={classNames(styles.right)}>
          <Link to="/register/basic/step-one" className={classNames(styles.rightMenu, styles.link)}>新供应商注册</Link>
        </div>
      </div>
    </header>
  );
}
function Menu(props) {
  const { visible } = props;
  const menuData = [
    {
      url: '/register/basic/step-one',
      text: '新供应商注册',
    },
    {
      url: '/principle',
      text: '采购原则',
    },
    {
      url: '/process',
      text: '供应商引入流程',
    },
    {
      onClick: () => {
        scrollToFeedback(props);
        props.onHide();
      },
      text: '投诉反馈',
    },
  ];
  let menuStyle = classNames(styles.menu);
  document.body.style.overflow = 'auto';
  if (visible) {
    document.body.style.overflow = 'hidden';
    menuStyle = classNames(styles.menu, styles.active);
  }
  return (
    <div className={menuStyle}>
      {
        menuData.map(({ url, text, onClick }) => {
          return <MenuItem url={url} onClick={onClick} text={text} key={url || text} />;
        })
      }
    </div>
  );
}
function MenuItem(props) {
  const innter = props.onClick ?
    (
      <div className={styles.link} onClick={props.onClick}>
        <h4 className={styles.linkText}>{props.text}</h4>
        <span>{'>'}</span>
      </div>
    ) :
    (
      <Link to={props.url} className={styles.link}>
        <h4 className={styles.linkText}>{props.text}</h4>
        <span>{'>'}</span>
      </Link>
    );
  return (
    <div className={styles.menuItem}>
      {innter}
    </div>
  );
}
class PhoneHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: false
    };
  }
  showMenu = () => {
    this.setState({
      menuVisible: !this.state.menuVisible
    });
  }
  render() {
    const navStyle = classNames(styles.navBar, styles.navBarBorder);
    return (
      <header className={navStyle}>
        <div className={styles.navbarHeader}>
          <img src={menuIcon} className={styles.iconBars} onClick={this.showMenu} alt="图片加载失败" />
          <Link to="/"> <img className={styles.logo} src={logo} alt="图片加载失败" /></Link>
        </div>
        <Menu {...this.props} visible={this.state.menuVisible} onHide={this.showMenu.bind(this)} />
      </header>
    );
  }
}
export default class App extends Component {
  render() {
    return (
      <div>
        <WebHeader {...this.props} />
        <PhoneHeader {...this.props} />
      </div>
    );
  }
}
